import Image, { StaticImageData } from 'next/image';
import useTranslation from 'next-translate/useTranslation';
import { ReactElement } from 'react';
import SubHeading from '../SubHeading';
interface Props {
  ctaIcon: ReactElement;
  ctaLabel: string;
  ctaLink?: string;
  image: StaticImageData;
  onClick?: VoidFunction;
}
const BannerWithCTAV2 = ({
  ctaIcon,
  ctaLabel,
  ctaLink,
  image,
  onClick
}: Props) => {
  const {
    t
  } = useTranslation('posts');
  const handleCtaClick = () => {
    if (ctaLink) {
      window.open(ctaLink, '_blank');
    } else if (onClick) {
      onClick();
    }
  };
  return <>
      <div className="relative max-h-[90vh]">
        <Image alt={ctaLabel} src={image} className="m-auto" data-sentry-element="Image" data-sentry-source-file="BannerWithCTAV2.tsx" />
        <div className="py-4 px-8 absolute bottom-0 w-full">
          <button className="flex w-webkit-fill justify-center items-center py-[15px] bg-primary-100 text-white border border-primary-70 rounded-lg" onClick={handleCtaClick}>
            <SubHeading className="text-center grow" data-sentry-element="SubHeading" data-sentry-source-file="BannerWithCTAV2.tsx">{t(ctaLabel)}</SubHeading>
            {ctaIcon}
          </button>
        </div>
      </div>
    </>;
};
export default BannerWithCTAV2;